module.exports = __webpack_public_path__ + "static/media/IMG-7.0c4d5ccd.jpg";